import { Link } from "@/i18n/navigation";

/**
 * Fil d'Ariane. `ariaLabel` nomme la navigation dans la langue de la page
 * (« Fil d'Ariane », "Breadcrumb") ; sans lui, le nom anglais d'origine reste.
 * Le dernier élément, la page en cours, porte aria-current.
 */
const Breadcrumb = ({ links, neutral, ariaLabel = "breadcrumb" }) => {
    return (
        <nav aria-label={ariaLabel}>
            <ol className="flex items-center gap-3">
                {links.map((link, index) => (
                    <li
                        key={`b-${index}`}
                        className="flex items-center text-sm"
                    >
                        {index < links.length - 1 ? (
                            <>
                                <Link
                                    href={link.link}
                                    className={
                                        neutral
                                            ? "text-inherit"
                                            : "text-primary"
                                    }
                                >
                                    {link.name}
                                </Link>
                                {/* Chevrons entre les liens */}
                                <span aria-hidden="true" className="ml-3.5 dark:text-grayDark-300">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="0.5em"
                                        height="0.5em"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            fill="none"
                                            stroke="currentColor"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="4"
                                            d="m7 4l8.33 6.04c2.226 1.615 2.226 2.306 0 3.92L7 20"
                                            color="currentColor"
                                        ></path>
                                    </svg>
                                </span>
                            </>
                        ) : (
                            <span aria-current="page" className="dark:text-lightBlue">
                                {link.name}
                            </span> // Dernier élément sans lien
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
